<template>
    <widget-card
        title="Recent activity (this event)"
        :loading="loading"
        :error="error"
        :empty="!loading && (!payload || payload.length === 0)"
        :hidden="hidden"
        @retry="fetchData"
    >
        <div v-if="payload && payload.length" class="feed" :class="{ 'is-dark': $vuetify.theme.dark }">
            <div v-for="item in payload" :key="item.activityLogId" class="row" @click="goTo(item)">
                <b>{{ item.actorName || 'Someone' }}</b>
                {{ verb(item.activityType) }}
                {{ item.entityType }}
                "{{ item.entityName }}"
                <span class="when">{{ item.createdDate | luxonPostedAgo }}</span>
            </div>
        </div>
    </widget-card>
</template>

<script>
import api from '@/api'
import WidgetCard from './WidgetCard.vue'

const VERBS = {
    Created: 'created',
    Updated: 'updated',
    Deleted: 'deleted',
    Submitted: 'submitted',
    Approved: 'approved',
    Flagged: 'flagged',
    Shared: 'shared',
    Unshared: 'unshared',
    SharedWithAll: 'shared-with-all',
    UnsharedWithAll: 'unshared-with-all',
}

const ROUTE_FOR_TYPE = {
    Encounter: 'readEncounter',
    Lammie: 'readLammie',
    Rumour: 'readRumour',
}

export default {
    name: 'RecentActivityWidget',
    components: { WidgetCard },
    props: {
        eventId: { type: Number, default: null },
        mode: { type: String, default: 'mine' },
        refreshKey: { type: Number, default: 0 },
    },
    data() {
        return { loading: false, error: null, payload: null, hidden: false, inFlightKey: null }
    },
    watch: {
        eventId: { handler: 'fetchData', immediate: true },
        mode: 'fetchData',
        refreshKey: 'fetchData',
    },
    methods: {
        endpointUrl() {
            const m = this.mode.charAt(0).toUpperCase() + this.mode.slice(1)
            return `dashboard/activity/${this.eventId}?mode=${m}`
        },
        async fetchData() {
            if (!this.eventId) { this.payload = null; return }
            const key = `${this.eventId}|${this.mode}`
            this.inFlightKey = key
            this.loading = true; this.error = null; this.hidden = false
            try {
                const data = await api.get(this.endpointUrl())
                if (this.inFlightKey !== key) return
                this.payload = data
            } catch (err) {
                if (this.inFlightKey !== key) return
                if (err.response && err.response.status === 403) { this.hidden = true; return }
                this.error = err
            } finally {
                if (this.inFlightKey === key) this.loading = false
            }
        },
        verb(activity) { return VERBS[activity] || activity },
        goTo(item) {
            const name = ROUTE_FOR_TYPE[item.entityType]
            if (!name) return
            this.$router.push({ name, params: { id: item.entityId } })
        },
    },
}
</script>

<style scoped>
.row { padding: 4px 0; border-bottom: 1px dotted #ddd; font-size: 12px; cursor: pointer; }
.row:hover { background: rgba(25,118,210,0.04); }
.row:last-child { border-bottom: none; }
.when { color: rgba(0,0,0,0.5); float: right; font-size: 10px; }
.feed.is-dark .row { border-bottom-color: rgba(255,255,255,0.18); }
.feed.is-dark .when { color: rgba(255,255,255,0.55); }
</style>
